import React from 'react';
import ReactDOM from 'react-dom';

import EditForm from './components/EditForm';


export default ({ id, name, description, greeting_text, question_areas, current_questions, target_audience_display }) => {
  const rootElem = $('#app').get(0)

  ReactDOM.render(
    <EditForm id={id} name={name} description={description} greeting_text={greeting_text}
      question_areas={question_areas} current_questions={current_questions}
      target_audience_display={target_audience_display} />, rootElem);
}
